import StringPromptInput from "app/widgets/PromptList/StringPromptInput";
import IntegerPromptInput from "app/widgets/PromptList/IntegerPromptInput";
import DecimalPromptInput from "app/widgets/PromptList/DecimalPromptInput";
import ListPromptInput from "app/widgets/PromptList/ListPromptInput";
import ListViewPromptInput from "app/widgets/PromptList/ListViewPromptInput";
import SwitchPromptInput from "app/widgets/PromptList/SwitchPromptInput";
import DatePromptInput from "app/widgets/PromptList/DatePromptInput";
import ReadOnlyPromptInput from "app/widgets/PromptList/ReadOnlyPromptInput";
import TextAreaPromptInput from "app/widgets/PromptList/TextAreaPromptInput";
import ButtonPromptInput from "app/widgets/PromptList/ButtonPromptInput";
import LinePromptInput from "app/widgets/PromptList/LinePromptInput";
import ImagePromptInput from "app/widgets/PromptList/ImagePromptInput";
import TablePromptInput from "app/widgets/PromptList/TablePromptInput";
import BlindStringPromptInput from "app/widgets/PromptList/BlindStringPromptInput";
import BlindDatePromptInput from "app/widgets/PromptList/BlindDatePromptInput";
import BlindDecimalPromptInput from "app/widgets/PromptList/BlindDecimalPromptInput";
import BlindIntegerPromptInput from "app/widgets/PromptList/BlindIntegerPromptInput";
import LinkPromptInput from "app/widgets/PromptList/LinkPromptInput";
import FileInputPromptInput from "app/widgets/PromptList/FileInputPromptInput";

export default {

    drawPlainStringInput: function(targetElement, prompt, replace, index, labels) {
        return this.drawInput(targetElement, prompt, StringPromptInput, true, replace, index, labels);
    },

    drawBlindStringInput: function(targetElement, prompt, replace, index, labels) {
        return this.drawInput(targetElement, prompt, BlindStringPromptInput, true, replace, index, labels);
    },

    drawReadOnlyInput: function(targetElement, prompt, replace, index, labels) {
        return this.drawInput(targetElement, prompt, ReadOnlyPromptInput, !!(this.options.showReadonlyLabel), replace, index, labels);
    },

    drawTextAreaInput: function(targetElement, prompt, replace, index, labels) {
        return this.drawInput(targetElement, prompt, TextAreaPromptInput, true, replace, index, labels);
    },

    drawPlainDecimalInput: function(targetElement, prompt, replace, index, labels) {
        return this.drawInput(targetElement, prompt, DecimalPromptInput, true, replace, index, labels);
    },

    drawBlindDecimalInput: function(targetElement, prompt, replace, index, labels) {
        return this.drawInput(targetElement, prompt, BlindDecimalPromptInput, true, replace, index, labels);
    },

    drawPlainIntegerInput: function(targetElement, prompt, replace, index, labels) {
        return this.drawInput(targetElement, prompt, IntegerPromptInput, true, replace, index, labels);
    },

    drawBlindIntegerInput: function(targetElement, prompt, replace, index, labels) {
        return this.drawInput(targetElement, prompt, BlindIntegerPromptInput, true, replace, index, labels);
    },

    drawPlainDateInput: function(targetElement, prompt, replace, index, labels) {
        return this.drawInput(targetElement, prompt, DatePromptInput, true, replace, index, labels);
    },

    drawBlindDateInput: function(targetElement, prompt, replace, index, labels) {
        return this.drawInput(targetElement, prompt, BlindDatePromptInput, true, replace, index, labels);
    },

    drawSwitchInput: function(targetElement, prompt, replace, index, labels) {
        return this.drawInput(targetElement, prompt, SwitchPromptInput, true, replace, index, labels);
    },

    drawListInput: function(targetElement, prompt, replace, index, labels) {
        return this.drawInput(targetElement, prompt, ListPromptInput, true, replace, index, labels);
    },

    drawListViewInput: function(targetElement, prompt, replace, index, labels) {
        return this.drawInput(targetElement, prompt, ListViewPromptInput, true, replace, index, labels);
    },

    drawButtonInput: function(targetElement, prompt, replace, index, labels) {
        return this.drawInput(targetElement, prompt, ButtonPromptInput, false, replace, index, labels);
    },

    drawTableInput: function(targetElement, prompt, replace, index, labels) {
        return this.drawInput(targetElement, prompt, TablePromptInput, true, replace, index, labels);
    },

    drawLineInput: function(targetElement, prompt, replace, index, labels) {
        return this.drawInput(targetElement, prompt, LinePromptInput, false, replace, index, labels);
    },

    drawImageInput: function(targetElement, prompt, replace, index, labels) {
        return this.drawInput(targetElement, prompt, ImagePromptInput, false, replace, index, labels);
    },

    drawLinkInput: function(targetElement, prompt, replace, index, labels) {
        return this.drawInput(targetElement, prompt, LinkPromptInput, false, replace, index);
    },

    drawFileUploadInput: function(targetElement, prompt, replace, index, labels) {
        return this.drawInput(targetElement, prompt, FileInputPromptInput, false, replace, index, labels);
    }
}
